export const useFormatAmount = () => {
  const store = useAppStore()
  const currencyConfig = computed(() => store.currencyConfig)
  const intlLanguage = computed(() => store.intlLanguage)

  const format = (amount: number) => formatAmount(amount, currencyConfig.value)
  const getCurrencyAcronym = () => currencyConfig.value?.currencyAcronym || ''
  const getCurrencySymbol = () => currencyConfig.value?.currencySymbol || ''
  const formatNumber = (amount: number) => formatNumeric(amount, intlLanguage.value)

  const getAmountDifferenceWithLarge = ({
    amount,
    largeAmount,
  }: {
    amount: number
    largeAmount: number
  }) => {
    const priceDifference = largeAmount - amount
    return format(priceDifference)
  }

  return {
    format,
    getCurrencyAcronym,
    getCurrencySymbol,
    getAmountDifferenceWithLarge,
    formatNumber,
  }
}
